/**
 * BLOCK: Header Block.
 */
import { __ } from '@wordpress/i18n'
import { disabledBlocks, i18n } from 'cartzillagb'
import { BlogPostsIcon } from '~cartzillagb/icons'


/**
 * Internal dependencies
 */
import save from './save'
import edit from './edit'

const schema = {
    className: {
        type: 'string',
    },

    design: {
        type: 'string',
        default: '1-level-light',
    },

    enableFullwidth: {
        type: 'boolean',
        default: false,
    },
    enableTopbar: {
        type: 'boolean',
        default: true,
    },

    enableHeaderSticky: {
        type: 'boolean',
        default: false,
    },

    enableAccount: {
        type: 'boolean',
        default: true,
    },

    enableCart: {
        type: 'boolean',
        default: true,
    },

    enableSearch: {
        type: 'boolean',
        default: true,

    },

    enableButton: {
        type: 'boolean',
        default: false,
    },

    enableOrderTracking: {
        type: 'boolean',
        default: true,
    },

    enableCompare: {
        type: 'boolean',
        default: true,
    },

    enableDepartmentMenu: {
        type: 'boolean',
        default: true,
    },

    departmentTitle: {
        type: 'string',
        default: __( 'Departments',i18n ),
    },

    departmentIcon: {
        type: 'string',
        default: __('czi-menu',i18n ),
    },

    mediaURL: {
        type: 'string',
    },

    skin: {
        type: 'string',
        default: 'light',
    },

    contactInfo: {
        type: 'string',
        default: 'Support',
    },

    promo: {
        type: 'string',
        //dangerouslySetInnerHTML : {__html: "<p>Your html code here.<p>"}
        default: __('Free shipping for order over $200',i18n ),
    },

    uniqueClass: {
        type: 'string',
    },
    logoImageID: {
        type: 'number',
    },
    logoImageUrl: {
        type: 'string',
    },

    mobileLogoImageID: {
        type: 'number',
    },
    mobileLogoImageUrl: {
        type: 'string',
    },
    enableSupportInfo: {
        type: 'boolean',
        default: true,
    },
    
    enableheaderSocialMenu: {
        type: 'boolean',
        default: true,
    },
    enableSiteContactInfo: {
        type: 'boolean',
        default: true,
    },
    
    supportInfoTitle: {
        type: 'string',
        default: __('Support',i18n ),
    },

    supportInfoIcon: {
        type: 'string',
        default: __('czi-support',i18n ),
    },
    supportText: {
        type: 'string',
        default: __('+1 (00) 33 169 7720',i18n ),
    },
    supportLink: {
        type: 'string',
        default: __('tel:+100331697720',i18n ),
    },

    contactInfoTitle: {
        type: 'string',
        default: __('Email',i18n ),
    },

    contactInfoIcon: {
        type: 'string',
        default: 'czi-mail',
    },
    contactText: {
        type: 'string',
        default: __('customer@example.com',i18n ),
    },
    contactLink: {
        type: 'string',
        default: __('mailto:customer@example.com',i18n ),
    },


    buttonText: {
        type: 'string',
        default: __('Buy Now',i18n ),
    },
    buttonUrl: {
        type: 'string',
        default: '#',
    },
    buttonDesign: {
        type: 'string',
        default: 'solid',
    },
    buttonIcon: {
        type: 'string',
        default: 'czi-cart',
    },
    buttonSize: {
        type: 'string',
        default: 'default',
    },
    buttonShape: {
        type: 'string',
        default: 'default',
    },
    buttonShadow: {
        type: 'boolean',
        default: false,
    },
    buttonButtonIcon: {
        type: 'boolean',
        default: false,
    },
    buttonIconAfterText: {
        type: 'boolean',
        default: false,
    },
    buttonBackgroundColor: {
        type: 'string',
        default: 'primary',
    },
    buttonAnimation: {
        type: 'string',
        default: 'none',
    },
    buttonDelay: {
        type: 'string',
        default: 'none',
    },
    enableWishlist: {
        type: 'boolean',
        default: true,
    },
    socialMenuTitle: {
        type: 'string',
        default: __('Follow us',i18n ),
    },

    enableGroceryDepartmentMenu: {
        type: 'boolean',
        default: true,
    },
    headerPrimaryMenuId : {
        type: 'number',
    },

    headerPrimaryMenuSlug : {
        type: 'string',
    },

    headerDepartmentMenuSlug : {
        type: 'string',
    },

    headerHandheldDepartmentMenuSlug : {
        type: 'string',
    },

    headerOffcanvasMenuSlug : {
        type: 'string',
    },


    headerDepartmentMenuID : {
        type: 'number',
    },

    headerOffcanvasMenuID : {
        type: 'number',
    },

    headerHandheldDepartmentMenuID : {
        type: 'number',
    },

    enableLanguageCurrency: {
        type: 'boolean',
        default: true,
    },
    

}


export const name = 'czgb/header'

export const settings = {
    title: __( 'Header' ),
    description: __( 'A large header title area. Typically used at the very top of a page.' ),
    icon: BlogPostsIcon,
    example: {},
    category: 'cartzillagb',
    keywords: [
        __( 'Header' ),
        __( 'CartzillaGb' ),
    ],
    supports: {
        inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
    },
    attributes: schema,

    edit,
    save,

    // CartzillaGB modules.
    // modules: {
    //     'advanced-responsive': true,
    // },
}